import React from "react";
import ReactDOM from "react-dom/client";
import App from "./app";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "../src/pages/Home/home.css";
// import 'bootstrap-icons/font/bootstrap-icons.css';
import "./assets/css/global.css";
import reportWebVitals from "./reportWebVitals";
import { api } from "./utils/apiCalling";
import { config } from "./utils/apiUrl";

const getScreenerJSONServlet = async () => {
  try {
    let ScreenerJSONServlet = await api.get(config.homeWarrantSearch + "/ric");
    if (ScreenerJSONServlet && Array.isArray(ScreenerJSONServlet)) {
      window.localStorage.setItem(
        "UnderlyingtickerdisplaynameMap",
        JSON.stringify(ScreenerJSONServlet),
      );
    } else {
      console.warn("ScreenerJSONServlet is not an array:", ScreenerJSONServlet);
      window.localStorage.setItem(
        "UnderlyingtickerdisplaynameMap",
        JSON.stringify([]),
      );
    }
  } catch (error) {
    console.error("Failed to fetch ScreenerJSONServlet:", error);
    window.localStorage.setItem(
      "UnderlyingtickerdisplaynameMap",
      JSON.stringify([]),
    );
  }
};
getScreenerJSONServlet();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

reportWebVitals();
